import React from "react";
import * as S from "./styles";

export const ReasonsInvest: React.FC = () => {
  return (
    <>
      <S.Container>
        <S.GroupMainText>
          <h2>10</h2>
          <h3>
            Motivos
            <br />
            para
            <br />
            Investir na
            <br />
            <span>Orthopride</span>
          </h3>
          <S.GroupInfo>
            <S.Card>
              <h3>1</h3>
              <div>
                <p>
                  Você não precisa ser dentista para ser um Franqueado
                  Orthopride
                </p>
              </div>
            </S.Card>
            <S.Card>
              <h3>2</h3>
              <div>
                <p>Zero casos de falência na rede</p>
              </div>
            </S.Card>
            <S.Card>
              <h3>3</h3>
              <div>
                <p>Software de gestão próprio</p>
              </div>
            </S.Card>
            <S.Card>
              <h3>4</h3>
              <div>
                <p>App do franqueado e paciente </p>
              </div>
            </S.Card>
            <S.Card>
              <h3>5</h3>
              <div>
                <p>Ferramentas de CRM e Inteligência de dados</p>
              </div>
            </S.Card>
            <S.Card>
              <h3>6</h3>
              <div>
                <p>Mais de 200 mil pacientes ativos</p>
              </div>
            </S.Card>
            <S.Card>
              <h3>7</h3>
              <div>
                <p>Cerca de 10 mil consultas ao dia na rede</p>
              </div>
            </S.Card>
            <S.Card>
              <h3>8</h3>
              <div>
                <p>Maior ticket médio do mercado de ortodontia</p>
              </div>
            </S.Card>
            <S.Card>
              <h3>9</h3>
              <div>
                <p>95% dos brasileiros necessitam de tratamento ortodôntico</p>
              </div>
            </S.Card>
            <S.Card className="margin">
              <h3>10</h3>
              <div>
                <p>Operação de baixa complexidade e alta rentabilidade</p>
              </div>
            </S.Card>
          </S.GroupInfo>
          <S.CaioJumping alt="Caio Castro" />
        </S.GroupMainText>
      </S.Container>
    </>
  );
};
